'use strict';

var React = require('react');
var Image = require('@swiggy-private/dls-web-core/dist/components/Image');
var index_es$1 = require('./index.es-55fa6858.js');
var index_es = require('./index.es-8c72aff8.js');
var OnceStart = require('./OnceStart-83973221.js');
var WidgetController_type = require('./WidgetController/type.js');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Button = styled__default['default'].button({
    color: "inherit",
    font: "inherit",
    margin: "0",
    background: "transparent",
    border: "none",
    outline: "none",
    padding: "0",
    appearance: "none",
    display: "flex",
});

const getDimensionValue = (componentStyle, dimension = {}, containerPadding) => {
    switch (dimension.type) {
        case WidgetController_type.IDimensionType.TYPE_RELATIVE: {
            switch (dimension.reference) {
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_WIDTH:
                    return `${(dimension.value || 1) * parseInt(componentStyle.width, 10)}px`;
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_HEIGHT:
                    return `${(dimension.value || 1) * parseInt(componentStyle.height, 10)}px`;
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH:
                case WidgetController_type.IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH:
                    return `${(dimension.value || 1) * window.innerWidth -
                        (index_es.X(containerPadding, "left", 0) +
                            index_es.X(containerPadding, "right", 0))}px`;
                default:
                    return dimension.value;
            }
        }
        default:
            return dimension.value;
    }
};
const ImageInfo = ({ img, style, containerPadding, analyticsVal, }) => {
    const componentRef = React.useRef(null);
    const { sdk } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const { clickAnalytics, impressionAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const onImageClick = React.useCallback(() => {
        var _a, _b;
        if (!index_es.N(clickAnalytics)) {
            clickAnalytics({
                action: "click-image-card-item",
                value: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.cardPosition,
                label: img.id,
                context: {
                    widgetId: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetId,
                    widget_vpos: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetPosition,
                    collectionId: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetId,
                },
            });
        }
        if (img.action && sdk) {
            if ((_a = img.action) === null || _a === void 0 ? void 0 : _a.sdkType) {
                sdk[img.action.sdkType]((_b = img.action) === null || _b === void 0 ? void 0 : _b.payload);
            }
            else {
                const navigateData = {
                    type: img.action.type || index_es$1.N.DEEPLINK,
                    link: img.action.link || "",
                };
                sdk.navigateToScreen(navigateData).catch(() => undefined);
            }
        }
    }, [analyticsVal, clickAnalytics, img.action, img.id, sdk]);
    const impressionImageCard = React.useCallback(() => {
        var _a;
        if (!index_es.N(impressionAnalytics)) {
            impressionAnalytics({
                action: "impression-image-card-item",
                value: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.cardPosition,
                label: img.id,
                context: {
                    widgetId: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetId,
                    widget_vpos: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetPosition,
                    is_capping_enabled: (_a = img.frequencyCapping) === null || _a === void 0 ? void 0 : _a.cappingEnabled,
                    collectionId: analyticsVal === null || analyticsVal === void 0 ? void 0 : analyticsVal.widgetId,
                    entity_type: img === null || img === void 0 ? void 0 : img.entityType,
                    entity_id: img.id,
                },
            });
        }
    }, [analyticsVal, img, impressionAnalytics]);
    React.useEffect(() => {
        if (!componentRef.current) {
            return;
        }
        componentRef.current.style.width = `${getDimensionValue(componentRef.current.style, style === null || style === void 0 ? void 0 : style.width, containerPadding)}`;
        componentRef.current.style.minWidth = componentRef.current.style.width;
        componentRef.current.style.height = `${getDimensionValue(componentRef.current.style, style === null || style === void 0 ? void 0 : style.height, containerPadding)}`;
        componentRef.current.style.minHeight = componentRef.current.style.height;
    }, [containerPadding, style]);
    return (React__default['default'].createElement(OnceStart.ElementObserver, { onViewEnter: impressionImageCard },
        React__default['default'].createElement(Button, { key: img.id, ref: componentRef, onClick: onImageClick },
            React__default['default'].createElement(Image.Image, { cloudinaryId: img.imageId, fallbackCloudinaryId: img.fallbackCloudinaryId }))));
};

const getImageInfoLayoutCards = (infoWithStyle, containerPadding, analyticsVal) => {
    var _a;
    if (infoWithStyle === null || infoWithStyle === void 0 ? void 0 : infoWithStyle.info) {
        return (_a = infoWithStyle === null || infoWithStyle === void 0 ? void 0 : infoWithStyle.info) === null || _a === void 0 ? void 0 : _a.map((img, index) => {
            analyticsVal = Object.assign(Object.assign({}, analyticsVal), { cardPosition: index + 1 });
            return (React__default['default'].createElement(ImageInfo, { img: img, style: infoWithStyle === null || infoWithStyle === void 0 ? void 0 : infoWithStyle.style, key: img.id, containerPadding: containerPadding, analyticsVal: analyticsVal }));
        });
    }
    return [];
};

exports.getImageInfoLayoutCards = getImageInfoLayoutCards;
//# sourceMappingURL=ImageInfoLayoutCard-1f4bac4a.js.map
